module.exports = __webpack_public_path__ + "static/media/faceshield.631c8084.png";